import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ICreateProductDto, IPagedCountryResultRequestDto, IProductDto, IUpdateProductDto } from 'src/app/models/backend';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  id: any;

  constructor(private http: HttpClient) { }

  // readonly url = environment.apiUrl+'Products/';
  readonly url = environment.apiUrl+'Products/'

  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
  
  .set('Authorization', `Bearer ${this.Token}`);
  
  createProduct(CreateProductDto: ICreateProductDto) {
    return this.http.post<ICreateProductDto>(this.url + 'CreateProduct', 
    CreateProductDto, { headers: this.headers })
  }
  uploadProductImage(payload: any) {
    console.log(payload)
    return this.http.post(`${this.url}UploadImage`, payload, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  updateProduct(UpdateProductDto: IUpdateProductDto) {
    return this.http.post<IUpdateProductDto>(this.url + 'UpdateProduct', 
    UpdateProductDto, { headers: this.headers })
  }

  getProducts(payload:IPagedCountryResultRequestDto)
  {
    return this.http.post<PagedResultDto<IProductDto>>(this.url+'GetProducts',payload, { headers: this.headers });
  }

  GetProduct(id: number): Observable<IProductDto> {
    return this.http.get<IProductDto>(`${this.url}GetProduct/${id}`, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  GetActiveProduct(){
    return this.http.post(`${this.url}GetActiveProducts`,null, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  DeleteProduct(id: number){
    return this.http.post(`${this.url}DeleteProduct/${id}`,null, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  getActiveLocations(){
    return this.http.post(`${environment.apiUrl}Locations/GetActiveLocations`,null, { headers: this.headers }).pipe(
      map(response=>response)
    )
  }
  getActiveCategories(){
    return this.http.post(`${environment.apiUrl}Categories/GetActiveCategories`,null, { headers: this.headers }).pipe(
      map(response=>response)
    )
  }
}
